export default {
  userDetails: {},
  properties: [],
  charmSubscribedProperties: [],
  filteredProperties: [],
  charmSubscribedAndFilteredProperties: [],
  charmSubscribedNotSelectedProperties:[]
};
